module.exports = __webpack_public_path__ + "assets/d9b026788ed20ad32061b5f08f732dc8.png";